import NavBar from './components/NavBar';
import HeroSection from './components/HeroSection';
import SocialProof from './components/SocialProof';
import ProblemSection from './components/ProblemSection';
import DifferentiatorSection from './components/DifferentiatorSection';
import HowItWorks from './components/HowItWorks';
import BenefitsTestimonials from './components/BenefitsTestimonials';
import ContactSection from './components/ContactSection';
import FooterSection from './components/FooterSection';

export default function HomePage() {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <main className="bg-[#0a0e1a] min-h-screen">
      <NavBar />
      <HeroSection onCTA={scrollToContact} />
      <SocialProof />
      <ProblemSection />
      <DifferentiatorSection />
      <HowItWorks />
      <BenefitsTestimonials onCTA={scrollToContact} />
      <ContactSection />
      <FooterSection />
    </main>
  );
}
